import { combineReducersInApp } from '@its/redux';
import drawerMenu from '@its/components/lib/Container components/DrawerMenuContainer/reducer';
import displays from './redux/display/reducer';
import timers from './redux/timer/reducer';
import templates from './redux/template/reducer';
import departments from './redux/department/reducer';
import plugins from './redux/plugin/reducer';

export default combineReducersInApp({
  drawerMenu,
  displays,
  timers,
  templates,
  departments,
  plugins,
});



/** WEBPACK FOOTER **
 ** ./src/reducer.js
 **/